<template>
  <div style="margin-left: 10px">
    <div>
      <text class="prcTitle">入库</text>
      <div class="prcButtonList">
        <div class="prcDiv" v-for="item in sawBladeEntry.eqInList" :key="item.id">
          <el-badge class="item" type="warning">
            <el-button type="primary" class="prcButton" @click="openInView(item,$event)">
              {{ item.label }}
            </el-button>
          </el-badge>
        </div>
      </div>
      <text class="prcTitle">出库</text>
      <div class="prcButtonList">
        <div class="prcDiv" v-for="item in sawBladeEntry.eqOutList" :key="item.id">
          <el-badge class="item" type="warning">
            <el-button type="primary" class="prcButton" @click="openOutView(item,$event)">
              {{ item.label }}
            </el-button>
          </el-badge>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "EqSawBladeEntryZhiZao",
  data() {
    return {
      sawBladeEntry: {},
      scanName: '',
      sawBladeData: []
    }
  },
  methods: {
    async getSawBladeEntry() {
      this.$http('eqSawBladeZhiZaoService.getSawBladeEntry',{},false).then(data => {
        this.sawBladeEntry = data
      }, errMsg => {
        return this.$message.error("获取锯片入口数据失败"+errMsg);
      })
    },
    fillParam(content) {
      return content.replace(/{(button|parentData)\.(\w+?)}/g, (str, type, key) => this[type][key]);
    },
    blur(event) {
      let target = event.target.nodeName == 'SPAN' ? event.target.parentNode : event.target;
      target.blur()
    },
    async openInView(item, event) {
      this.blur(event)
      let windowObj = {}
      windowObj.component = "equipment/EqSawBladeInZhiZaoAdd"
      windowObj.name = this.fillParam(item.label)
      windowObj.height = 600
      windowObj.width = 900
      windowObj.parentData = item;
      windowObj.max = this.$store.getters['core/getGlobalWindowMax']
      windowObj.$fn = {
        reSearch: () => this.$emit('reSearch')
      }

      this.$store.dispatch('core/openWindow', windowObj)
    },

    openOutView(item, event) {
      this.blur(event)
      let windowObj = {}
      windowObj.component = "equipment/EqSawBladeOutZhiZaoAdd"
      windowObj.name = this.fillParam(item.label)
      windowObj.height = 600
      windowObj.width = 900
      windowObj.parentData = item;
      windowObj.max = this.$store.getters['core/getGlobalWindowMax']
      windowObj.$fn = {
        reSearch: () => this.$emit('reSearch')
      }

      this.$store.dispatch('core/openWindow', windowObj)
    },

    getSawBlade() {
      this.$http('eqSawBladeZhiZaoService.getSawBlade',this.scanName).then(data => {
        this.sawBladeData = data
      }, errMsg => {
        return this.$message.error(+errMsg);
      })
    },

  },
  created() {
    this.getSawBladeEntry()
  }
}
</script>
<style lang="less" scoped>
.item ::v-deep(.el-badge__content.is-fixed) {
  right: 40px !important;
}
</style>

<style scoped>
.lock1 {
  font-size: 18px;
  color: darkgoldenrod;
  position: absolute;
  left: 140px;
  top: -5px;
}

.item {
  background-color: transparent;
}

.prcTitle {
  font-size: 35px;
  font-weight: bold;
}

.prcButton {
  width: 280px;
  height: 80px;
  font-size: 30px;
}

.prcButtonList {
  display: flex;
  flex-wrap: wrap;
}

.prcDiv {
  margin: 10px 40px 10px 0;
}
</style>